export default "__VITE_ASSET__12wi4bVt__"